import API from '../../../api';
import FormStep from '../../Form/FormStep';

export default {
	mixins: [FormStep],
	methods: {
		save() {
			if(this.id) {
				return API.updateInsight(this.id, this.currentStep, this.formData);
			} else {
				return  API.createInsight(this.formData).then(response => {
					this.$store.commit('form/setId', response.id);
				});
			}
		},
		sendToPreview() {
            this.$refs.fileinput.$el.querySelector('.form__validation').innerText = '';
            this.$refs.fileinput.$el.querySelector('.dz-clickable').classList.remove('error');

            this.$validator.validateAll().then(success => {
                if(!this.formData.attachments.length){
                    this.$refs.fileinput.$el.querySelector('.form__validation').innerText = 'Please upload a file';
                    this.$refs.fileinput.$el.querySelector('.dz-clickable').classList.add('error');

                    return false;
                }

                if(!success){
                    return false;
                }

                let url = window.location.href;
                const eventCategory = url.includes("create") ? "create" : "update";
                if(window.gtag) {
                    console.log("Submitting Insight submit event")

                    window.gtag("event", "form_submission", {
                        "event_category": eventCategory,
                        "event_label": "insight"
                    });
                }
                this.submit()
                .then(ev => {
                    this.$router.push({ name: 'preview-document', params: { insight_id: this.id } });
                });
            });
		}
	},
}
